// extracted by mini-css-extract-plugin
export default {"pos-device-login-connect":"vSZVzl","posDeviceLoginConnect":"vSZVzl","connect-button":"K0mwPH","connectButton":"K0mwPH","codeInput":"dA1P75"};